import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  baseURL = "http://localhost:9091/Note"

  constructor(private notehttp: HttpClient) { }

  addNote(id: any, note: any): Observable<any> {
    return this.notehttp.post(this.baseURL + "/addNote/" + id, note);
  }

  addNote2(note:any  , id:any , image:File ):Observable<any>{
    const formData = new FormData();
formData.append("title", note.title);
formData.append("start", note.start);
formData.append("end", note.end);
formData.append("description", note.description);
return this.notehttp.post<any>(`${this.baseURL}/addNote2/${id}`, formData);
  }

  getNoteById(id: any): Observable<any> {
    return this.notehttp.get(this.baseURL + "/getNoteById/" + id);
  }

  deleteNote(id: any): Observable<any> {
    return this.notehttp.delete(this.baseURL + "/deleteNote/" + id);
  }
}
